import { Client, type ClientOptions } from "./rest";
import {
  apiKeys,
  artists,
  auth,
  careers,
  channels,
  currencies,
  feed,
  health,
  notifications,
  orders,
  organizations,
  places,
  profiles,
  roadmap,
  sitemaps,
  users,
} from "./sdk";

export class TonightPass {
  public readonly client: Client;

  public readonly apiKeys;
  public readonly artists;
  public readonly auth;
  public readonly careers;
  public readonly channels;
  public readonly currencies;
  public readonly feed;
  public readonly health;
  public readonly orders;
  public readonly organizations;
  public readonly places;
  public readonly profiles;
  public readonly roadmap;
  public readonly sitemaps;
  public readonly users;
  public readonly notifications;

  constructor(options: ClientOptions) {
    this.client = new Client(options);

    this.apiKeys = apiKeys(this.client);
    this.artists = artists(this.client);
    this.auth = auth(this.client);
    this.careers = careers(this.client);
    this.channels = channels(this.client);
    this.currencies = currencies(this.client);
    this.feed = feed(this.client);
    this.health = health(this.client);
    this.orders = orders(this.client);
    this.organizations = organizations(this.client);
    this.places = places(this.client);
    this.profiles = profiles(this.client);
    this.roadmap = roadmap(this.client);
    this.sitemaps = sitemaps(this.client);
    this.users = users(this.client);
    this.notifications = notifications(this.client);
  }
}
